export enum RemarksFormFields {
  OperationalRemarks = 'operationalRemarks',
  HazmatEmergencyContactInfo = 'hazmatEmergencyContactInfo',
  PieceCount = 'pieceCount',
  OsdContact = 'osdContact',
}
